import { render, staticRenderFns } from "./RankBar.vue?vue&type=template&id=8dc2d43a&scoped=true&"
import script from "./RankBar.vue?vue&type=script&lang=js&"
export * from "./RankBar.vue?vue&type=script&lang=js&"
import style0 from "./RankBar.vue?vue&type=style&index=0&id=8dc2d43a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc2d43a",
  null
  
)

export default component.exports